import { render, staticRenderFns } from "./CompanyBoardCategoryModal.vue?vue&type=template&id=4f9c536f"
import script from "./CompanyBoardCategoryModal.vue?vue&type=script&lang=js"
export * from "./CompanyBoardCategoryModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyBoardCategoryModal.vue?vue&type=style&index=0&id=4f9c536f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports